<!-- Sticky Header -->
<div class="sticky top-16 left-0 right-0 z-40 bg-white border-b border-gray-200">
  <div class="px-4 py-4 sm:py-6">
    <h2 class="text-center">
      <span class="block text-xl sm:text-2xl font-bold text-gray-900">
        Create a New Request
      </span>
      <span class="mt-1 block text-sm text-gray-600">
        Select the type of request you'd like to create
      </span>
    </h2>
  </div>
</div>

<!-- Main Content -->
<div class="px-4 py-4">
  <div class="max-w-lg mx-auto space-y-8">
    <!-- Menu Grid -->
    <div class="grid grid-cols-2 gap-3 sm:gap-4">
      <button
        *ngFor="let button of buttons"
        (click)="openSlideOut(button)"
        class="group relative bg-white p-4 sm:p-6 rounded-xl shadow-sm border border-gray-200 hover:border-indigo-500 hover:shadow-md active:scale-[0.98] transition-all duration-200"
      >
        <div class="flex flex-col space-y-1.5">
          <span class="text-base sm:text-lg font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors">
            {{ button }}
          </span>
          <span class="text-xs sm:text-sm text-gray-600">
            {{ assignedToRoleGroup(button) }}
          </span>
        </div>
        <div class="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 text-gray-500 group-hover:text-indigo-500 group-hover:translate-x-1 transition-all duration-200">
          <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </div>
      </button>
    </div>

    <!-- Quick Stats -->
    <!-- <div class="border-t border-gray-200 pt-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">Today's Overview</h3>
      <div class="grid grid-cols-2 gap-4"> -->
        <!-- Active Projects -->
        <!-- <div class="bg-gray-50 p-4 rounded-lg">
          <p class="text-sm text-gray-500">Active Projects</p>
          <div class="flex items-baseline">
            <p class="text-2xl font-bold text-gray-900">4</p>
            <p class="ml-2 text-xs text-gray-500">vehicles</p>
          </div>
        </div> -->
        
        <!-- Parts Pending -->
        <!-- <div class="bg-gray-50 p-4 rounded-lg">
          <p class="text-sm text-gray-500">Parts Pending</p>
          <div class="flex items-baseline">
            <p class="text-2xl font-bold text-gray-900">3</p>
            <p class="ml-2 text-xs text-gray-500">requests</p>
          </div>
        </div> -->

        <!-- Weekly Progress -->
        <!-- <div class="col-span-2 bg-gray-50 p-4 rounded-lg">
          <p class="text-sm text-gray-500">Weekly Completion Progress</p>
          <div class="mt-2 relative pt-1">
            <div class="flex items-center justify-between">
              <div>
                <span class="text-2xl font-bold text-gray-900">7</span>
                <span class="ml-1 text-sm text-gray-500">of 10 vehicles</span>
              </div>
              <span class="text-sm font-semibold text-green-600">70%</span>
            </div>
            <div class="overflow-hidden h-2 mt-2 text-xs flex rounded bg-gray-200">
              <div class="w-[70%] shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"></div>
            </div>
          </div>
        </div> -->

        <!-- Time Stats -->
        <!-- <div class="col-span-2 grid grid-cols-3 gap-2 bg-gray-50 p-4 rounded-lg">
          <div>
            <p class="text-xs text-gray-500">Avg. Cycle Time</p>
            <p class="text-lg font-bold text-gray-900">4.2</p>
            <p class="text-xs text-gray-500">days</p>
          </div>
          <div>
            <p class="text-xs text-gray-500">Supplements</p>
            <p class="text-lg font-bold text-gray-900">2</p>
            <p class="text-xs text-gray-500">pending</p>
          </div>
          <div>
            <p class="text-xs text-gray-500">Phase Changes</p>
            <p class="text-lg font-bold text-gray-900">5</p>
            <p class="text-xs text-gray-500">today</p>
          </div>
        </div> 
      </div>
    </div> -->

    <!-- Quick Stats -->
    <!-- <div class="border-t border-gray-200 pt-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">Today's Overview</h3>
      <div class="grid grid-cols-2 gap-4">
        <div class="bg-gray-50 p-4 rounded-lg">
          <p class="text-sm text-gray-500">Open Requests</p>
          <p class="text-2xl font-bold text-gray-900">12</p>
        </div>
        <div class="bg-gray-50 p-4 rounded-lg">
          <p class="text-sm text-gray-500">Completed Today</p>
          <p class="text-2xl font-bold text-gray-900">8</p>
        </div>
      </div>
    </div> -->

    <!-- Recent Requests -->
    <!-- <div class="border-t border-gray-200 pt-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">Recent Requests</h3>
      <div class="space-y-3">
        <div *ngFor="let request of recentRequests" 
             class="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
          <div>
            <p class="font-medium text-gray-900">{{ request.type }}</p>
            <p class="text-sm text-gray-500">{{ request.date | date:'short' }}</p>
          </div>
          <span class="text-sm font-medium" 
                [ngClass]="{
                  'text-green-600': request.status === 'Completed',
                  'text-blue-600': request.status === 'In Progress',
                  'text-yellow-600': request.status === 'Pending'
                }">
            {{ request.status }}
          </span>
        </div>
      </div>
    </div> -->

    <!-- Help Section -->
    <div class="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 mt-auto">
      <div class="bg-blue-50 p-4 rounded-lg">
        <h3 class="text-sm font-medium text-blue-800 flex items-center">
          <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
          </svg>
          Need Help?
        </h3>
        <p class="mt-2 text-sm text-blue-700">
          Not sure which request type to choose? Contact your supervisor or check the 
          <!-- <button class="font-medium underline">request guide</button> -->
        </p>
      </div>
    </div>
  </div>
</div>



<!-- End of Request Buttons -->

<div *ngIf="slideOutVisible" @slideInOut 
     class="fixed inset-y-0 right-0 w-screen max-w-md bg-gray-50 shadow-xl z-50 transform transition-transform overflow-y-auto"
     [ngClass]="{'translate-x-full': !slideOutVisible, 'translate-x-0': slideOutVisible}">
  
    <!-- Header -->
    <div class="sticky top-0 bg-white border-b border-gray-200 z-10">
      <div class="px-4 py-4 flex items-center justify-between">
      <h2 class="text-2xl font-semibold text-gray-900">New Request</h2>
      <button (click)="toggleSlideOut()" 
              class="rounded-full p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500">
        <span class="sr-only">Close panel</span>
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    
     <!-- Request Type Banner -->
    <div class="px-4 py-4 bg-indigo-50 border-y border-indigo-100">
      <div class="flex flex-col space-y-1">
        <span class="text-xl font-semibold text-indigo-700">{{ task.requestName }}</span>
        <span class="text-sm text-indigo-600">{{ assignedToRoleGroup(task.requestName) }}</span>
      </div>
    </div>
  </div>

  <!-- Form Content -->
  <div class="p-4">
    <form (ngSubmit)="onSubmit()" #taskForm="ngForm" class="space-y-6">
      <!-- Comments Section -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <label for="comments" class="block text-sm font-medium text-gray-700 mb-2">Comments</label>
        <textarea 
          id="comments" 
          name="comments" 
          [(ngModel)]="task.comments" 
          required
          placeholder="Describe your request..."
          class="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none h-48"
        ></textarea>
      </div>

      <!-- General Photos Section -->
      <section *ngIf="showGeneralMediaUpload(task.request)" class="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-sm font-medium text-gray-900">General Photos</h3>
        </div>
        <div class="grid grid-cols-3 gap-2">
          <div *ngFor="let photo of generalPhotos; let i = index" class="relative aspect-square rounded-lg overflow-hidden bg-gray-100">
            <img [src]="photo.url"
                 class="w-full h-full object-cover transition-transform duration-200"
                 [style.transform]="'rotate(' + (photo.rotation || 0) + 'deg)'"
                 [alt]="'Photo ' + (i + 1)"
                 (click)="openPhotoPreview(photo)">
            <button (click)="removeGeneralPhoto(i, $event)"
                    class="absolute top-1 right-1 text-red-500 bg-white rounded-full p-1 shadow">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
            <div *ngIf="photo.isProcessing" class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div class="animate-spin rounded-full h-8 w-8 border-4 border-white border-t-transparent"></div>
            </div>
          </div>
          <!-- Camera and Gallery Buttons for General Photos -->
          <div *ngIf="generalPhotos.length < 3" class="flex flex-col space-y-2">
            <!-- Take Photo Button -->
            <label class="relative aspect-square rounded-lg border-2 border-dashed border-gray-300 hover:border-indigo-500 transition-colors cursor-pointer flex items-center justify-center overflow-hidden">
              <input
                type="file"
                accept="image/*"
                capture="environment"
                class="sr-only"
                (change)="onGeneralPhotoSelected($event)">
              <div class="text-center">
                <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                <span class="mt-1 block text-xs text-gray-600">Take Photo</span>
              </div>
              <div *ngIf="isCapturing" 
                  class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div class="animate-spin rounded-full h-8 w-8 border-4 border-white border-t-transparent"></div>
              </div>
            </label>
            <!-- Choose from Gallery Button -->
            <label class="relative aspect-square rounded-lg border-2 border-dashed border-gray-300 hover:border-indigo-500 transition-colors cursor-pointer flex items-center justify-center overflow-hidden">
              <input
                type="file"
                accept="image/*"
                class="sr-only"
                (change)="onGeneralPhotoSelected($event)">
              <div class="text-center">
                <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M4 12V8a2 2 0 012-2h12a2 2 0 012 2v4M4 12l4-4a2 2 0 012.828 0l2.344 2.344a2 2 0 002.828 0L20 8"/>
                </svg>
                <span class="mt-1 block text-xs text-gray-600">Choose from Gallery</span>
              </div>
              <div *ngIf="isCapturing" 
                  class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div class="animate-spin rounded-full h-8 w-8 border-4 border-white border-t-transparent"></div>
              </div>
            </label>
          </div>
        </div>
      </section>

      <!-- Sublet Section -->
      <section *ngIf="showSubletButton" class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-sm font-medium text-gray-900">Associated Sublets</h3>
          <button 
            type="button" 
            (click)="toggleSubletComponent()"
            class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full text-indigo-700 bg-indigo-50 hover:bg-indigo-100"
          >
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            Add Sublet
          </button>
        </div>

        <!-- Selected Sublets with Photos -->
        <div class="space-y-4">
          <div *ngFor="let sublet of selectedSubletOptions" 
              class="relative bg-gray-50 rounded-lg p-4">
            <!-- Sublet Header -->
            <div class="flex items-center justify-between mb-3">
              <span class="text-base font-medium text-gray-900">{{ sublet.name }}</span>
              <button type="button" (click)="removeSubletOption(sublet)" 
                      class="text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>

           <!-- Photo Upload Section with Advanced Camera Controls -->
            <div class="space-y-3">
              <div class="flex items-center justify-between">
                <p class="text-sm text-gray-600">Photos ({{ getSubletPhotos(sublet).length }}/3)</p>
                
                <!-- Camera Controls -->
                <div class="flex items-center space-x-2">
                 
                </div>
              </div>
              
              <!-- Photo Grid -->
              <div class="grid grid-cols-3 gap-2">
                <!-- Existing Photos -->
                <div *ngFor="let photo of getSubletPhotos(sublet); let i = index" 
                    class="relative aspect-square rounded-lg overflow-hidden bg-gray-100">
                  <!-- Photo Preview -->
                 
                      <img [src]="photo.url" 
                        [attr.data-photo-index]="i"
                        [style.transform]="'rotate(' + (photo.rotation || 0) + 'deg)'"
                        class="w-full h-full object-cover transition-transform duration-200"
                        [alt]="'Photo ' + (i + 1)"
                        (click)="openPhotoPreview(photo)">
                  
                  <!-- Photo Controls -->
                  <div class="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-40 transition-opacity flex items-center justify-center opacity-0 hover:opacity-100">
                    <div class="flex space-x-2">
                      <!-- Rotate -->
                      <button (click)="rotatePhoto(sublet, i, $event)"
                              class="p-1.5 rounded-full bg-white text-gray-700 hover:bg-gray-100">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                        </svg>
                      </button>
                      <!-- Delete -->
                      <button (click)="removePhoto(sublet, i, $event)"
                              class="p-1.5 rounded-full bg-white text-red-500 hover:bg-red-50">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- Loading Overlay -->
                  <div *ngIf="photo.isProcessing" 
                      class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div class="animate-spin rounded-full h-8 w-8 border-4 border-white border-t-transparent"></div>
                  </div>
                </div>

                <!-- Camera Button -->
                <div *ngIf="getSubletPhotos(sublet).length < 3" class="flex flex-col space-y-2">
                  <!-- Take Photo Button -->
                  <label class="relative aspect-square rounded-lg border-2 border-dashed border-gray-300 hover:border-indigo-500 transition-colors cursor-pointer flex items-center justify-center overflow-hidden">
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      class="sr-only"
                      (change)="onPhotoSelected($event, sublet)">
                    <div class="text-center">
                      <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                              d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                              d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                      <span class="mt-1 block text-xs text-gray-600">Take Photo</span>
                    </div>
                    <div *ngIf="isCapturing" 
                        class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                      <div class="animate-spin rounded-full h-8 w-8 border-4 border-white border-t-transparent"></div>
                    </div>
                  </label>
                  <!-- Choose from Gallery Button -->
                  <label class="relative aspect-square rounded-lg border-2 border-dashed border-gray-300 hover:border-indigo-500 transition-colors cursor-pointer flex items-center justify-center overflow-hidden">
                    <input
                      type="file"
                      accept="image/*"
                      class="sr-only"
                      (change)="onPhotoSelected($event, sublet)">
                    <div class="text-center">
                      <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                              d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M4 12V8a2 2 0 012-2h12a2 2 0 012 2v4M4 12l4-4a2 2 0 012.828 0l2.344 2.344a2 2 0 002.828 0L20 8"/>
                      </svg>
                      <span class="mt-1 block text-xs text-gray-600">Choose from Gallery</span>
                    </div>
                    <div *ngIf="isCapturing" 
                        class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                      <div class="animate-spin rounded-full h-8 w-8 border-4 border-white border-t-transparent"></div>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <!-- Photo Preview Modal -->
            <div *ngIf="previewPhoto"
                class="fixed inset-0 z-50 bg-black bg-opacity-75 flex items-center justify-center"
                (click)="closePhotoPreview()">
              <div class="relative max-w-2xl w-full mx-4" (click)="$event.stopPropagation()">
                <!-- Close Button -->
                <button (click)="closePhotoPreview()" class="absolute top-2 right-2 z-10 bg-white rounded-full p-1 shadow">
                  <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
                <img [src]="previewPhoto.url" 
                    [style.transform]="'rotate(' + (previewPhoto.rotation || 0) + 'deg)'"
                    class="w-full rounded-lg shadow-xl transition-transform duration-200"
                    alt="Preview">
                <!-- Controls -->
                <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 bg-black bg-opacity-50 rounded-full px-4 py-2">
                  <button (click)="rotatePreviewPhoto(-90, $event)"
                          class="p-2 rounded-full text-white hover:bg-white hover:bg-opacity-20">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"/>
                    </svg>
                  </button>
                  <button (click)="rotatePreviewPhoto(90, $event)"
                          class="p-2 rounded-full text-white hover:bg-white hover:bg-opacity-20">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Priority Toggle -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-2">
            <svg class="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
            <span class="text-sm font-medium text-gray-900">Urgent Request</span>
          </div>
          <button
            type="button"
            class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
            role="switch"
            [attr.aria-checked]="task.isUrgent"
            [ngClass]="task.isUrgent ? 'bg-indigo-600' : 'bg-gray-200'"
            (click)="toggleUrgency()"
          >
            <span class="sr-only">Mark as Urgent</span>
            <span
              aria-hidden="true"
              class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
              [ngClass]="task.isUrgent ? 'translate-x-5' : 'translate-x-0'"
            ></span>
          </button>
        </div>
      </div>

      <!-- Submit Button -->
      <button type="submit"
              [disabled]="isSubmitting"
              class="w-full flex justify-center py-3 px-4 text-sm font-medium rounded-xl text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 shadow-sm">
        <div class="flex items-center space-x-2">
          <span *ngIf="!isSubmitting">Create Request</span>
          <span *ngIf="isSubmitting">Creating Request...</span>
          <div *ngIf="isSubmitting" class="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
        </div>
      </button>
    </form>
  </div>
</div>


<app-sublet-selection *ngIf="subletService.showSublet$ | async" (closeSublet)="toggleSubletComponent()"></app-sublet-selection>

